export default __webpack_public_path__ + "static/media/table-7.74d59451.png";